import type { Table } from '@tanstack/react-table';

import type { FilterType } from '../types/filter-meta';
import type { ActiveFilterData } from '../types/toolbar-slot-props';
import { getFilterLabel } from './get-filter-label';
import { getFilterOptions } from './get-filter-options';

/**
 * Transforms active column filters from TanStack Table into serializable ActiveFilterData.
 */
export function getActiveFilters<TData>(table: Table<TData>): ActiveFilterData[] {
  const columnFilters = table.getState().columnFilters;

  return columnFilters
    .map((filter) => {
      const column = table.getColumn(filter.id);
      if (!column) return null;

      const filterMeta = column.columnDef.meta?.filter;
      if (!filterMeta) return null;

      const label = getFilterLabel(column);
      const filterType = column.columnDef.filterFn as FilterType;

      return {
        columnId: filter.id,
        label,
        filterType,
        filterMeta,
        value: filter.value,
        options: getFilterOptions(column),
      };
    })
    .filter((f): f is ActiveFilterData => f !== null);
}
